import { type FiltersDomain } from '../types/domain/filters-domain'

export const getValidFilters = (filters: FiltersDomain) => {
  const values = Object.entries(filters).filter(
    ([_, value]) => value !== null && value !== undefined
  )
  return Object.fromEntries(values)
}
